export default __webpack_public_path__ + "static/media/mobile_applications_l.8025af77.jpg";